import { ConfigProvider } from "antd";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Main from "./Main";

function App() {
  return (
    <ConfigProvider
      theme={{ token: { colorPrimary: " rgba(122, 74, 255, 1) 0%," } }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Main />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
